import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: window._env_?.VITE_SENTRY_ADDRESS ?? import.meta.env.VITE_SENTRY_ADDRESS,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // enabled:
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: 0,
  replaysSessionSampleRate: 0,
  environment:
    window._env_?.VITE_SENTRY_CONFIG_ENV ??
    import.meta.env.VITE_SENTRY_CONFIG_ENV,
  // release: import.meta.env.VITE_APP_VERSION,
  ignoreErrors: [],
});
